import { memo, useMemo } from 'react';
import { IconPlus, MediaControl, MediaItem, Menu, type MenuItem, Stub } from '@direct-frontend/components';
// eslint-disable-next-line @direct-frontend/modules/no-restricted-entity-imports -- типы поля медиа
import { MEDIA_TYPE_VIDEO, type MediaV2Field } from '#shared/lib/form';
import { MAX_PRODUCT_MEDIA_FIELD_IMAGE_COUNT, MAX_PRODUCT_MEDIA_FIELD_VIDEO_COUNT } from '#shared/lib/product';
import styles from './ProductDraggableGalleryMediaField.module.css';

interface ProductDraggableGalleryMediaFieldAddButtonProps {
    onAddPhoto: () => void;
    onAddVideo: () => void;
    itemWidth: number;
    itemHeight: number;
    media: MediaV2Field[];
}

export const ProductDraggableGalleryMediaFieldAddButton = memo(function ProductDraggableGalleryMediaFieldAddButton({
    onAddPhoto,
    onAddVideo,
    itemWidth,
    itemHeight,
    media,
}: ProductDraggableGalleryMediaFieldAddButtonProps) {
    const menuItems = useMemo<MenuItem[]>(() => {
        const videoDisabled =
            media.filter((item) => item.type === MEDIA_TYPE_VIDEO).length >= MAX_PRODUCT_MEDIA_FIELD_VIDEO_COUNT;
        const imageDisabled =
            media.filter((item) => item.type === 'IMAGE').length >= MAX_PRODUCT_MEDIA_FIELD_IMAGE_COUNT;

        return [
            {
                key: 'add-photo',
                content: imageDisabled ? 'Изображения добавлены' : 'Добавить изображение',
                value: 'add-photo',
                onAction: onAddPhoto,
                disabled: imageDisabled,
                caption: imageDisabled
                    ? `Можно добавить только ${MAX_PRODUCT_MEDIA_FIELD_IMAGE_COUNT} изображений`
                    : undefined,
            },
            {
                key: 'add-video',
                content: videoDisabled ? 'Видео добавлено' : 'Добавить видео',
                value: 'add-video',
                onAction: onAddVideo,
                disabled: videoDisabled,
                caption: videoDisabled ? 'Можно добавить только одно видео' : undefined,
            },
        ];
    }, [onAddPhoto, onAddVideo, media]);

    return (
        <Menu
            aria-label="Контекстное меню"
            size="m"
            items={menuItems}
            placement={['right-start', 'top-end', 'bottom-end']}
            trigger={
                <div className={styles.menuTrigger}>
                    <MediaItem
                        borderRadius="14"
                        controls={
                            <MediaControl isAlwaysVisible position="center">
                                <IconPlus size="20" color="gray" role="supplementary" />
                            </MediaControl>
                        }
                        media={<Stub width={itemWidth} height={itemHeight} />}
                    />
                </div>
            }
        />
    );
});
